const state = {
  months: [
    {short: 'Jan', number: '01'},
    {short: 'Feb', number: '02'},
    {short: 'Mar', number: '03'},
    {short: 'Apr', number: '04'},
    {short: 'May', number: '05'},
    {short: 'Jun', number: '06'},
    {short: 'Jul', number: '07'},
    {short: 'Aug', number: '08'},
    {short: 'Sep', number: '09'},
    {short: 'Oct', number: '10'},
    {short: 'Nov', number: '11'},
    {short: 'Dec', number: '12'},
  ],
};

const mutations = {

};

const actions = {

};

const getters = {
  months(state) {
    return state.months
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/general.js